<template>
  <div class="projectApply">
    <div style="display: flex; flex-direction: row">
      <div style="flex: 1">
        <div class="projectInfo">
          <el-form :model="form" ref="form" :rules="rules" label-width="90px">
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="项目名称:">
                  <el-input
                    v-model="form.projectName"
                    placeholder="请输入项目名称"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="项目经理:">
                  <div @click="addPeople('manager')">
                    <el-input
                      readonly
                      v-model="form.managerName"
                      placeholder="请选择项目经理"
                    ></el-input>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="合同名称:">
                  <el-select
                    style="width: 428px"
                    v-model="form.contractName"
                    filterable
                    remote
                    reserve-keyword
                    placeholder="请输入合同名称"
                    :remote-method="remoteMethod"
                    :loading="loading"
                    @change="changeHt"
                  >
                    <el-option
                      v-for="item in htList"
                      :key="item.contractNo"
                      :label="item.contractName"
                      :value="item"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="合同编号:">
                  <el-select
                    style="width: 300px"
                    v-model="form.contractNo"
                    filterable
                    remote
                    reserve-keyword
                    placeholder="请选择合同"
                    :remote-method="remoteMethod"
                    :loading="loading"
                    @change="changeHt"
                  >
                    <el-option
                      v-for="item in htList"
                      :key="item.contractNo"
                      :label="item.contractName"
                      :value="item"
                    ></el-option>
                  </el-select>
                  <el-button
                    type="text"
                    style="margin-left: 10px"
                    @click="lookFile"
                    >查看附件</el-button
                  >
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="项目总额:">
                  <el-input
                    v-model="form.amount"
                    placeholder="请输入项目总额"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="项目日期:">
                  <el-date-picker
                    v-model="form.date"
                    value-format="yyyy-MM-dd"
                    style="width: 428px"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="详细说明:" prop="description">
                  <el-input
                    v-model="form.description"
                    maxLength="100"
                    placeholder="请输入合同说明，100字以内"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="派单人:" prop="distributeId">
                  <div @click="addPeople('distribute')">
                    <el-input
                      readonly
                      v-model="form.distributeName"
                      placeholder="请选择派单人"
                    ></el-input>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>

            <!-- 合同内清单 -->
            <div style="font-size: 16px; font-weight: 600; padding: 10px 0">
              项目清单(合同内)
            </div>
            <div>
              <el-row
                style="margin-top: 10px; margin-bottom: 10px"
                :gutter="24"
              >
                <el-col :span="5">
                  <div class="xingxing">工作项</div>
                </el-col>

                <el-col :span="3">
                  <div class="xingxing">规格</div>
                </el-col>

                <el-col :span="3">
                  <div class="xingxing">工程量</div>
                </el-col>
                <el-col :span="2">
                  <div>单位</div>
                </el-col>
                <el-col :span="3">
                  <div>单价（元）</div>
                </el-col>
                <el-col :span="2">
                  <div>分项汇总</div>
                </el-col>
                <el-col :span="5">
                  <div>备注</div>
                </el-col>
                <el-col :span="1">
                  <div></div>
                </el-col>
              </el-row>
              <el-row
                v-for="(item, index) in insideItemList"
                :key="'insideWorkList' + index"
                :gutter="24"
              >
                <el-col :span="5">
                  <el-form-item
                    labelWidth="0"
                    :rules="rules.workItemId"
                    :prop="`itemList[${getInsideIndex(index)}].workItemId`"
                  >
                    <el-select
                      v-model="item.workItemId"
                      placeholder="请选择"
                      @change="changeWorkList($event, getInsideIndex(index))"
                    >
                      <el-option
                        v-for="item in workItemOptions"
                        :key="item.id"
                        :label="item.allName"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="3">
                  <el-form-item labelWidth="0">
                    <el-select
                      v-model="item.speWorkItemId"
                      placeholder="请选择规格"
                      @change="
                        changeChildrenList($event, getInsideIndex(index))
                      "
                      :disabled="!item.workItemId"
                      clearable
                    >
                      <el-option
                        v-for="child in getSpecOptions(getInsideIndex(index))"
                        :key="child.id"
                        :label="child.speWorkItemName || child.itemName"
                        :value="child.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="3">
                  <el-form-item
                    labelWidth="0"
                    :rules="rules.quantity"
                    :prop="`itemList[${getInsideIndex(index)}].quantity`"
                  >
                    <el-input
                      v-model="item.quantity"
                      oninput="value=value.replace(/[^0-9.]/g,'')"
                      placeholder="请输入工程量"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="2">
                  <el-form-item labelWidth="0">
                    <div>{{ item.workItemUnitName }}</div>
                  </el-form-item>
                </el-col>
                <el-col :span="3">
                  <el-form-item labelWidth="0">
                    <el-input
                      v-model="item.price"
                      oninput="value=value.replace(/[^0-9.]/g,'')"
                      placeholder="请输入单价"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="2">
                  <el-form-item labelWidth="0">
                    <div>
                      ￥{{ (item.quantity * item.price) | filterMoney }}
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item labelWidth="0" prop="remark">
                    <el-input
                      v-model="item.remark"
                      placeholder="请输入备注"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="1">
                  <li
                    @click="deleteWorkList(getInsideIndex(index))"
                    style="
                      font-size: 20px;
                      color: red;
                      padding-top: 10px;
                      cursor: pointer;
                    "
                    class="el-icon-remove"
                  ></li>
                </el-col>
              </el-row>
            </div>
            <div
              style="
                border-bottom: 1px solid #ccc;
                width: 100%;
                padding-bottom: 20px;
              "
            >
              <div style="float: right; height: 40px; line-height: 40px">
                合同内总计：
                <span style="color: red">￥{{ insideAllMoney }}</span>
              </div>
              <el-button type="primary" @click="addWorkList('inside')">
                添加合同内项目
              </el-button>
            </div>

            <!-- 合同外清单 -->
            <div
              style="
                font-size: 16px;
                font-weight: 600;
                padding: 10px 0;
                margin-top: 20px;
              "
            >
              项目清单(合同外)
            </div>
            <div>
              <el-row
                style="margin-top: 10px; margin-bottom: 10px"
                :gutter="24"
              >
                <el-col :span="5">
                  <div class="xingxing">工作项</div>
                </el-col>

                <el-col :span="3">
                  <div>规格</div>
                </el-col>

                <el-col :span="3">
                  <div class="xingxing">工程量</div>
                </el-col>
                <el-col :span="2">
                  <div>单位</div>
                </el-col>
                <el-col :span="3">
                  <div>单价（元）</div>
                </el-col>
                <el-col :span="2">
                  <div>分项汇总</div>
                </el-col>
                <el-col :span="5">
                  <div>备注</div>
                </el-col>
                <el-col :span="1">
                  <div></div>
                </el-col>
              </el-row>
              <el-row
                v-for="(item, index) in outsideItemList"
                :key="'outsideWorkList' + index"
                :gutter="24"
              >
                <el-col :span="5">
                  <el-form-item
                    labelWidth="0"
                    :rules="rules.workItemId"
                    :prop="`itemList[${getOutsideIndex(index)}].workItemId`"
                  >
                    <el-select
                      v-model="item.workItemId"
                      placeholder="请选择"
                      @change="changeWorkList($event, getOutsideIndex(index))"
                    >
                      <el-option
                        v-for="item in workItemOptions"
                        :key="item.id"
                        :label="item.allName"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="3">
                  <el-form-item labelWidth="0">
                    <el-select
                      v-model="item.speWorkItemId"
                      placeholder="请选择规格"
                      @change="
                        changeChildrenList($event, getOutsideIndex(index))
                      "
                      :disabled="!item.workItemId"
                      clearable
                    >
                      <el-option
                        v-for="child in getSpecOptions(getOutsideIndex(index))"
                        :key="child.id"
                        :label="child.speWorkItemName || child.itemName"
                        :value="child.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="3">
                  <el-form-item
                    labelWidth="0"
                    :rules="rules.quantity"
                    :prop="`itemList[${getOutsideIndex(index)}].quantity`"
                  >
                    <el-input
                      v-model="item.quantity"
                      oninput="value=value.replace(/[^0-9.]/g,'')"
                      placeholder="请输入工程量"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="2">
                  <el-form-item labelWidth="0">
                    <div>{{ item.workItemUnitName }}</div>
                  </el-form-item>
                </el-col>
                <el-col :span="3">
                  <el-form-item
                    labelWidth="0"
                    :rules="rules.price"
                    :prop="`itemList[${getOutsideIndex(index)}].price`"
                  >
                    <el-input
                      v-model="item.price"
                      oninput="value=value.replace(/[^0-9.]/g,'')"
                      placeholder="请输入单价"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="2">
                  <el-form-item labelWidth="0">
                    <div>
                      ￥{{ (item.quantity * item.price) | filterMoney }}
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item labelWidth="0" prop="remark">
                    <el-input
                      v-model="item.remark"
                      placeholder="请输入备注"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="1">
                  <li
                    @click="deleteWorkList(getOutsideIndex(index))"
                    style="
                      font-size: 20px;
                      color: red;
                      padding-top: 10px;
                      cursor: pointer;
                    "
                    class="el-icon-remove"
                  ></li>
                </el-col>
              </el-row>
            </div>
            <div
              style="
                border-bottom: 1px solid #ccc;
                width: 100%;
                padding-bottom: 20px;
              "
            >
              <div style="float: right; height: 40px; line-height: 40px">
                合同外总计：
                <span style="color: red">￥{{ outsideAllMoney }}</span>
              </div>
              <el-button type="primary" @click="addWorkList('outside')">
                添加合同外项目
              </el-button>
            </div>
            <template>
              <div style="font-size: 16px; font-weight: 600; padding: 10px 0">
                地域范围
                <span style="font-size: 12px; font-weight: 400">
                  （最小可分解区域）
                </span>
              </div>
              <div
                style="
                  border-bottom: 1px solid #ccc;
                  width: 100%;
                  padding: 10px 0 20px 0;
                "
              >
                <template v-if="selectRoadList && selectRoadList.length">
                  <div class="areaItem" v-for="(item, index) in selectRoadList">
                    <li class="el-icon-location"></li>
                    <div class="areaName">{{ item.roadName }}</div>
                    <div
                      class="el-icon-remove deleteBtn"
                      @click="deleteRoad(index)"
                    ></div>
                  </div>
                </template>
                <el-button type="primary" plain @click="chooseRoad">
                  选择区县街道
                </el-button>
                <el-button v-show="false" type="danger" plain @click="addRoad">
                  新增道路(小区)
                </el-button>
              </div>
            </template>
            <el-input
              style="margin-top: 20px"
              type="textarea"
              :rows="4"
              v-model="form.content"
              placeholder="请输入项目补充内容"
            ></el-input>

            <template>
              <div style="font-size: 16px; font-weight: 600; padding: 10px 0">
                审批流程
              </div>
              <div>
                <el-form-item label="项目经理" prop="auditManagerName">
                  <span
                    @click="addPeople('auditManager')"
                    style="color: #409eff; cursor: pointer"
                  >
                    {{
                      form.auditManagerName
                        ? form.auditManagerName
                        : "请选择项目经理"
                    }}
                  </span>
                </el-form-item>
                <el-form-item label="部门经理" prop="auditDepterName">
                  <span
                    @click="addPeople('auditDepter')"
                    style="color: #409eff; cursor: pointer"
                  >
                    {{
                      form.auditDepterName
                        ? form.auditDepterName
                        : "请选择部门经理"
                    }}
                  </span>
                </el-form-item>
              </div>
              <div
                style="
                  border-bottom: 1px solid #ccc;
                  width: 100%;
                  padding: 10px 0 20px 0;
                "
              ></div>
            </template>
          </el-form>
        </div>
      </div>

      <work-flow v-if="form.status === 3" :list="flowList"></work-flow>
    </div>
    <div
      class="foot"
      v-if="
        zcId === null || zcId === '' || zcId === undefined || form.status === 0
      "
    >
      <el-button type="primary" @click="submit(1)">提交</el-button>
      <el-button type="primary" @click="submit(0)" plain>暂存</el-button>
    </div>
    <div class="foot" v-else>
      <el-button type="primary" @click="$router.back()">确定</el-button>
    </div>
    <add-people
      :addPeopleVisible="addPeopleVisible"
      :dialogTitle="dialogTitle"
      :peopleList="selectPeopleList"
      :isLimit="true"
      @closeAddPeopleVisible="closeAddPeople"
      @submitPeople="submitPeople"
    ></add-people>
    <el-dialog
      :visible.sync="roadVisible"
      title="输入地域范围"
      width="380px"
      @close="closeDialog"
    >
      <el-select
        style="width: 288px"
        v-model="selectRoad.roadName"
        filterable
        remote
        reserve-keyword
        placeholder="请输入地域范围"
        :remote-method="remoteMethodRoad"
        :loading="loading"
        @change="changeRoad"
      >
        <el-option
          v-for="item in roadList"
          :key="item.townCode"
          :label="item.townName"
          :value="item"
        ></el-option>
      </el-select>
      <div style="margin-top: 20px">
        <el-button type="primary" @click="submitRoad">确定</el-button>
        <el-button @click="closeDialog">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="addRoadVisible"
      title="新增道路(小区)"
      width="380px"
      @close="closeDialog"
    >
      <el-select
        style="width: 288px"
        v-model="addRoadForm.townName"
        filterable
        remote
        reserve-keyword
        placeholder="请选择区域"
        @change="changeArea"
      >
        <el-option
          v-for="item in areaList"
          :key="item.dictValue"
          :label="item.dictName"
          :value="item"
        ></el-option>
      </el-select>
      <el-input
        style="width: 288px; margin-top: 10px"
        v-model="addRoadForm.roadName"
        placeholder="请输入道路(小区)名称"
      ></el-input>
      <div style="margin-top: 20px">
        <el-button type="primary" @click="submitAddRoad">确定</el-button>
        <el-button @click="closeDialog">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import AddPeople from "@/components/AddPeople";
import ProjectApplyApi from "@/api/projectApply";
import CommonApi from "@/api/common";
import commonUtil from "../../utils/commonUtil";
import WorkFlow from "./components/WorkFlow.vue";
import projectApply from "../../api/projectApply";
import { cloneDeep } from "lodash-es";
export default {
  name: "ProjectApply",
  components: {
    AddPeople,
    WorkFlow,
  },
  data() {
    return {
      zcIdOne: "",
      item: {
        workItemId: "清理",
      },
      addRoadForm: {
        roadName: "",
        townCode: "",
        townName: "",
      },
      areaList: [],
      flowList: [],
      addPeopleVisible: false,
      roadVisible: false,
      addRoadVisible: false,
      dialogTitle: "",
      selectPeopleList: [],
      loading: false,
      htList: [],
      roadList: [],
      selectRoad: {
        roadCode: "",
        roadName: "",
      },
      form: {
        actionType: "", //0：暂存 1：提交
        amount: "",
        content: "",
        contractName: "",
        contractNo: "",
        description: "",
        endDate: "",
        date: [],
        auditDepterName: "",
        auditDepterId: "",
        auditManagerName: "",
        auditManagerId: "",
        auditUserList: [],
        itemList: [
          {
            type: 1, //类型：1=合同内，2=合同外
            amount: "",
            price: "",
            quantity: "",
            remark: "",
            workItemId: "",
            workItemName: "",
            workItemUnitName: "",
            speWorkItemId: "", //工作项清单ID（规格）
            speWorkItemName: "", //工作项清单名称（规格）
          },
        ],
        managerId: "",
        managerName: "",
        projectName: "",
        startDate: "",
        total: 0,
        distributeId: "",
        distributeName: "",
        type: "", //类型：1=合同内，2=合同外
      },
      rules: {
        projectName: [
          {
            required: true,
            message: "请输入项目名称",
            trigger: ["blur", "change"],
          },
        ],
        managerId: [
          {
            required: true,
            message: "请选择项目经理",
            trigger: ["blur", "change"],
          },
        ],
        distributeId: [
          {
            required: true,
            message: "请选择派单人",
            trigger: ["blur", "change"],
          },
        ],
        amount: [
          {
            required: true,
            message: "请输入项目总额",
            trigger: ["blur", "change"],
          },
        ],
        date: [
          {
            required: true,
            message: "请选择项目日期",
            trigger: ["blur", "change"],
          },
        ],
        description: [
          {
            required: true,
            message: "请输入项目说明",
            trigger: ["blur", "change"],
          },
        ],
        workItemId: [
          {
            required: true,
            message: "请选择工作项",
            trigger: ["blur", "change"],
          },
        ],
        // specId改为非必选，可以为空
        // specId: [
        //   {
        //     required: true,
        //     message: '请选择规格',
        //     trigger: ['blur', 'change'],
        //   },
        // ],
        quantity: [
          {
            required: true,
            message: "请输入工程量",
            trigger: ["blur", "change"],
          },
        ],
        price: [
          {
            required: true,
            message: "请输入单价",
            trigger: ["blur", "change"],
          },
        ],
        contractName: [
          {
            required: true,
            message: "请输入合同名称",
            trigger: ["blur", "change"],
          },
        ],
        contractNo: [
          {
            required: true,
            message: "请选择合同",
            trigger: ["blur", "change"],
          },
        ],
      },
      workItemOptions: [],
      value: "",
      selectRoadList: [],
      selectPeopleType: "",
      selectPeopleObj: {
        manager: [],
        auditManager: [],
        auditDepter: [],
        distribute: [],
      },
    };
  },
  computed: {
    // 合同内清单
    insideItemList() {
      if (!this.form.itemList) return [];
      return this.form.itemList.filter((item) => item.type === 1);
    },
    // 合同外清单
    outsideItemList() {
      if (!this.form.itemList) return [];
      return this.form.itemList.filter((item) => item.type === 2);
    },
    // 合同内总计
    insideAllMoney() {
      let sum = 0;
      if (this.insideItemList) {
        this.insideItemList.forEach((item) => {
          if (!isNaN(item.quantity * item.price)) {
            sum += item.quantity * item.price;
          }
        });
      }
      return sum;
    },
    // 合同外总计
    outsideAllMoney() {
      let sum = 0;
      if (this.outsideItemList) {
        this.outsideItemList.forEach((item) => {
          if (!isNaN(item.quantity * item.price)) {
            sum += item.quantity * item.price;
          }
        });
      }
      return sum;
    },
    // 总计
    allMoney() {
      // console.log('getallmoney');
      let sum = 0;
      this.form.itemList.forEach((item) => {
        if (!isNaN(item.quantity * item.price)) {
          sum += item.quantity * item.price;
        }
      });
      return sum;
    },
    zcId() {
      return this.$route.query.id || "";
    },
  },
  filters: {
    filterMoney(val) {
      if (isNaN(val)) {
        return 0;
      } else {
        return val;
      }
    },
  },
  created() {
    if (this.$route.query.id) {
      this.zcIdOne = this.$route.query.id;
      console.log("this.zcIdOne", this.zcIdOne);
    }
    if (this.$route.query.cacheData) {
      try {
        const cachedForm = JSON.parse(this.$route.query.cacheData);
        Object.assign(this.form, cachedForm);
      } catch (e) {
        console.error("缓存数据解析错误", e);
      }
    }
    if (sessionStorage.getItem("type")) {
      const localForm = JSON.parse(sessionStorage.getItem("localForm")) || {};
      console.log("localForm.selectRoadList =>", localForm.selectRoadList);

      this.selectRoadList = [];
      this.selectPeopleList = [];
      this.form.itemList = {};
      this.form.projectName = localForm.projectName;
      this.form.managerName = localForm.managerName;
      this.form.contractName = localForm.contractName;
      this.form.contractNo = localForm.contractNo;
      this.form.amount = localForm.amount;
      this.form.date = localForm.date;
      this.form.status = localForm.status;
      this.form.description = localForm.description;
      this.form.distributeName = localForm.distributeName;
      this.form.itemList = localForm.itemList;
      this.selectPeopleList = localForm.selectPeopleList;
      this.selectRoadList = localForm.selectRoadList;
      this.form.content = localForm.content;
      this.form.auditDepterName = localForm.auditDepterName;
      this.form.auditManagerName = localForm.auditManagerName;
      this.zcIdOne = localForm.zcIdOne;
    } else {
      this.queryProjectDetail();
    }
    this.getAllWorkLit();
    this.getDictList();
    this.queryContractInfo();
    // this.queryRoadList();
    this.getStreetList();
  },
  mounted() {
    sessionStorage.removeItem("type");
  },
  methods: {
    //查看附件合同信息
    lookFile() {
      if (!this.form.contractName) {
        this.$message.error("请选择合同");
        return;
      }
      // this.$router.push({
      //   name: 'projectContractDetails',
      //   query: { contractInfo: this.form.contractName, pageId: '1' },
      // });
      let localForm = {};
      localForm.projectName = this.form.projectName;
      localForm.managerName = this.form.managerName;
      localForm.contractName = this.form.contractName;
      localForm.contractNo = this.form.contractNo;
      localForm.amount = this.form.amount;
      localForm.date = this.form.date;
      localForm.status = this.form.status;
      localForm.description = this.form.description;
      localForm.distributeName = this.form.distributeName;
      localForm.itemList = this.form.itemList;
      localForm.selectPeopleList = this.selectPeopleList;
      localForm.selectRoadList = this.selectRoadList;
      localForm.content = this.form.content;
      localForm.auditDepterName = this.form.auditDepterName;
      localForm.auditManagerName = this.form.auditManagerName;
      localForm.zcIdOne = this.zcIdOne;
      sessionStorage.setItem("localForm", JSON.stringify(localForm));
      sessionStorage.setItem("type", 1);
      this.$router.push({
        name: "projectContractDetails",
        query: {
          contractInfo: this.form.contractName,
          pageId: "1",
          // cacheData: JSON.stringify(this.form), // 携带当前表单数据
        },
      });
    },
    // queryRoadList() {
    //   CommonApi.queryRoadList({
    //     roadName: '',
    //   }).then((res) => {
    //     if (res.data.code === 200) {
    //       this.roadList = res.data.data;
    //     } else {
    //       this.roadList = [];
    //     }
    //   });
    // },
    queryContractInfo() {
      ProjectApplyApi.queryContractInfo({
        contractName: "",
        status: 0,
        pageDto: {
          current: 0,
          size: 100000,
        },
      }).then((res) => {
        if (res.data.code === 200) {
          this.htList = res.data.data.records;
        } else {
          this.htList = [];
        }
      });
    },
    //接口信息列表
    getStreetList() {
      ProjectApplyApi.getStreetList({
        current: 0,
        size: 2000,
        townCode: "",
        townName: "",
      }).then((res) => {
        if (res.data.code === 200) {
          console.log("-->", res);
          this.roadList = res.data.data.records;
        }
      });
    },
    getDictList() {
      ProjectApplyApi.getDictList({
        dictCode: "town_code",
      }).then((res) => {
        if (res.data.code === 200) {
          this.areaList = res.data.data;
        }
      });
    },
    queryProjectDetail() {
      if (this.zcId) {
        ProjectApplyApi.queryProjectDetail({
          id: this.zcId,
        }).then((res) => {
          if (res.data.data) {
            console.log(res.data.data, "==================");
            const { auditFlow, auditFlowId, auditFlowStep, ...newForm } =
              res.data.data;
            Object.assign(this.form, newForm);
            this.form.date = [];
            this.form.date.push(new Date(this.form.startDate));
            this.form.date.push(new Date(this.form.endDate));
            this.form.roadList.forEach((item) => {
              this.selectRoadList.push({
                roadId: item.roadId,
                roadName: item.roadName,
              });
            });
            console.log("---==>", this.selectRoadList);
          }
        });
      }
    },
    ///AddPeople组件回调函数
    closeAddPeople() {
      this.addPeopleVisible = false;
    },
    submitPeople(val) {
      this.addPeopleVisible = false;
      if (val && val.length > 0) {
        //JSON.parse(JSON.stringify(val))
        // this.selectPeopleList = cloneDeep(val)
        const persons = cloneDeep(val);
        this.selectPeopleObj[this.selectPeopleType] = persons;
        // if (this.selectPeopleType === 'manager') {
        //   this.form.managerId = persons[0].id
        //   this.form.managerName =persons[0].name
        // }
        // if (this.selectPeopleType === 'auditManager') {
        //   this.form.auditManagerId = persons[0].id
        //   this.form.auditManagerName = persons[0].name
        // }

        // if (this.selectPeopleType === 'auditDepter') {
        //   this.form.auditDepterId = persons[0].id
        //   this.form.auditDepterName = persons[0].name
        // }
        // if (this.selectPeopleType === 'distribute') {
        this.form[`${this.selectPeopleType}Id`] = persons[0].id;
        this.form[`${this.selectPeopleType}Name`] = persons[0].name;
        // }
      }
    },
    addPeople(type) {
      this.selectPeopleList = this.selectPeopleObj[type];
      this.selectPeopleType = type;
      this.addPeopleVisible = true;
    },
    ///AddPeople组件回调函数

    getAllWorkLit() {
      ProjectApplyApi.queryAllWorkItem().then((res) => {
        if (res.data.code === 200) {
          console.log("===>", res.data.data);
          this.workItemOptions = res.data.data.map((item) => {
            item.allName = item.workName + "-" + item.itemName;
            return item;
          });
        } else {
          this.$message({
            message: res.data.message,
            type: "error",
          });
        }
      });
    },
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        ProjectApplyApi.queryContractInfo({
          contractName: query,
          status: 0,
          pageDto: {
            current: 0,
            size: 100000,
          },
        }).then((res) => {
          if (res.data.code === 200) {
            this.htList = res.data.data.records;
          } else {
            this.htList = [];
          }
          this.loading = false;
        });
      } else {
        this.htList = [];
      }
    },
    remoteMethodRoad(query) {
      if (query !== "") {
        this.loading = true;
        CommonApi.queryRoadList({
          roadName: query,
        }).then((res) => {
          if (res.data.code === 200) {
            this.roadList = res.data.data;
          } else {
            this.roadList = [];
          }
          this.loading = false;
        });
      } else {
        this.roadList = [];
      }
    },
    changeArea(value) {
      this.addRoadForm.townCode = value.dictCode;
      this.addRoadForm.townName = value.dictName;
      // console.log(this.addRoadForm);
    },
    addRoad() {
      this.addRoadVisible = true;
      this.addRoadForm = {
        roadName: "",
        townCode: "",
        townName: "",
      };
    },
    chooseRoad() {
      this.roadVisible = true;
    },
    deleteRoad(index) {
      this.selectRoadList.splice(index, 1);
    },
    submitRoad() {
      // console.log(this.selectRoad.length);

      if (Object.keys(this.selectRoad).length === 0) {
        this.$message({ message: "请输入地域范围", type: "error" });
        return;
      }

      this.selectRoadList.push(JSON.parse(JSON.stringify(this.selectRoad)));
      this.selectRoad = {};
      this.roadVisible = false;
    },
    submitAddRoad() {
      if (this.addRoadForm.roadName === "") {
        this.$message({ message: "请输入地域范围", type: "error" });
        return;
      }

      this.areaList.forEach((value, idnex) => {
        if (value.dictName === this.addRoadForm.townName) {
          this.addRoadForm.townCode = value.dictValue;
        }
      });

      CommonApi.saveRoad(this.addRoadForm).then((res) => {
        if (res.data.code === 200) {
          this.$message({
            message: "地域范围添加成功，请进入选择页面选择",
            type: "success",
          });

          let newRode = {
            id: this.addRoadForm.townCode,
            roadName: this.addRoadForm.townName,
          };

          this.selectRoadList.push(newRode);
          this.selectRoad = { id: "", roadName: "" };
          this.roadVisible = false;
          this.addRoadVisible = false;
        } else {
          this.$message({ message: res.data.message, type: "error" });
        }
      });
    },
    closeDialog() {
      this.roadVisible = false;
      this.addRoadVisible = false;
    },
    changeRoad(value) {
      this.selectRoad.roadName = value.townName;
      this.selectRoad.roadCode = value.townCode;
      console.log("selectRoad", this.selectRoad);
    },
    changeHt(value) {
      // console.log(value);
      this.form.contractNo = value.contractNo;
      this.form.contractName = value.contractName;
    },
    changeWorkList(value, index) {
      // console.log(value);
      this.workItemOptions.forEach((item) => {
        if (value === item.id) {
          this.form.itemList[index].workItemId = item.id;
          this.form.itemList[index].workItemName = item.itemName;
          this.form.itemList[index].workItemUnitName = item.itemUnitName;
          // 清空规格选择
          this.form.itemList[index].specId = "";
          this.form.itemList[index].specName = "";
        }
      });
    },
    // 获取当前工作项的规格选项
    getSpecOptions(index) {
      const workItemId = this.form.itemList[index].workItemId;
      if (!workItemId) {
        return [];
      }
      const workItem = this.workItemOptions.find(
        (item) => item.id === workItemId
      );
      return workItem && workItem.children ? workItem.children : [];
    },
    // 处理规格选择变化
    changeChildrenList(value, index) {
      const workItemId = this.form.itemList[index].workItemId;
      if (!workItemId) {
        return;
      }
      // 处理规格清空的情况
      if (!value) {
        this.form.itemList[index].speWorkItemId = "";
        this.form.itemList[index].speWorkItemName = "";
        return;
      }
      const workItem = this.workItemOptions.find(
        (item) => item.id === workItemId
      );
      if (workItem && workItem.children) {
        const spec = workItem.children.find((child) => child.id === value);
        if (spec) {
          this.form.itemList[index].speWorkItemId = spec.id;
          this.form.itemList[index].speWorkItemName =
            spec.speWorkItemName || spec.itemName || "";
          // // 如果规格有单价，则自动填充
          // if (spec.price) {
          //   this.form.itemList[index].price = spec.price;
          // }
          // // 如果规格有单位，则自动填充
          // if (spec.itemUnitName) {
          //   this.form.itemList[index].workItemUnitName = spec.itemUnitName;
          // }
        }
      }
    },
    // 获取合同内清单在原数组中的索引
    getInsideIndex(index) {
      if (!this.form.itemList) return -1;
      let count = 0;
      for (let i = 0; i < this.form.itemList.length; i++) {
        if (this.form.itemList[i].type === 1) {
          if (count === index) {
            return i;
          }
          count++;
        }
      }
      return -1;
    },
    // 获取合同外清单在原数组中的索引
    getOutsideIndex(index) {
      if (!this.form.itemList) return -1;
      let count = 0;
      for (let i = 0; i < this.form.itemList.length; i++) {
        if (this.form.itemList[i].type === 2) {
          if (count === index) {
            return i;
          }
          count++;
        }
      }
      return -1;
    },
    addWorkList(type = "outside") {
      this.$set(this.form.itemList, this.form.itemList.length, {
        type: type === "inside" ? 1 : 2, //类型：1=合同内，2=合同外
        amount: "",
        price: "",
        quantity: "",
        remark: "",
        workItemId: "",
        workItemName: "",
        workItemUnitName: "",
        speWorkItemId: "", //工作项清单ID（规格）
        speWorkItemName: "", //工作项清单名称（规格）
      });
    },
    deleteWorkList(index) {
      if (this.form.itemList.length > 1) {
        this.form.itemList.splice(index, 1);
      } else {
        this.$message.warning("至少保留一项工作清单");
      }
    },
    submit(type) {
      console.log(this.form.date);
      this.form.actionType = type;
      if (this.form.date[0].length === 10) {
        this.form.startDate = this.form.date[0];
        this.form.endDate = this.form.date[1];
      } else {
        this.form.startDate = commonUtil.parseTime(
          this.form.date[0],
          "yyyy-MM-dd"
        );
        this.form.endDate = commonUtil.parseTime(
          this.form.date[1],
          "yyyy-MM-dd"
        );
      }

      if (this.selectPeopleList.length > 0) {
        this.form.managerName = this.selectPeopleList[0].name;
      }
      this.form.auditUserList = [];
      this.form.auditUserList.push(
        {
          auditUserId: this.form.auditManagerId,
          auditUserName: this.form.auditManagerName,
        },
        {
          auditUserId: this.form.auditDepterId,
          auditUserName: this.form.auditDepterName,
        }
      );

      this.form.roadList = [];
      this.selectRoadList.forEach((item) => {
        console.log("item", item);
        this.form.roadList.push({
          roadId: item.roadCode || item.roadId,
          roadName: item.roadName,
        });
      });
      this.form.itemList.forEach((item) => {
        item.amount = item.price * item.quantity;
      });
      // 根据项目类型设置type字段：有合同内项目为1，只有合同外项目为2
      this.form.type =
        this.insideItemList.length > 0
          ? 1
          : this.outsideItemList.length > 0
          ? 2
          : 1;
      this.form.total = this.allMoney;
      let { date, ...newForm } = this.form;
      // console.log(newForm);
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          this.$message({
            message: "请完善申请信息",
            type: "error",
          });
          return;
        }
        if (!this.selectRoadList || this.selectRoadList.length === 0) {
          this.$message({
            message: "请添加地域范围",
            type: "error",
          });
          return;
        }
        console.log(newForm, "newForm");

        ProjectApplyApi.saveProject(newForm).then((res) => {
          if (res.data.code === 200) {
            this.$message({
              message: type === 0 ? "暂存成功" : "提交成功",
              type: "success",
            });
            this.$router.back();
          } else {
            this.$message({
              message: res.data.message,
              type: "error",
            });
          }
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.projectApply {
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: auto;

  .el-form-item {
    margin-left: 0 !important;
  }

  .projectInfo {
    width: 1100px;
    padding: 20px;

    .areaItem {
      width: auto;
      display: inline-block;
      height: 40px;
      line-height: 40px;
      position: relative;
      border: 1px solid #ccc;
      margin-right: 20px;
      padding: 0 6px;

      li {
        font-size: 20px;
      }

      .areaName {
        display: inline-block;
        margin-left: 6px;
        vertical-align: top;
      }

      .deleteBtn {
        position: absolute;
        right: -8px;
        top: -8px;
        font-size: 20px;
        color: red;
        cursor: pointer;
      }
    }

    .xingxing::before {
      content: "*";
      color: #f56c6c;
      margin-right: 4px;
    }
  }

  .foot {
    width: 100%;
    padding: 20px;
    padding-top: 0;
  }
}
</style>
